import { render, staticRenderFns } from "./CreativeListTable.vue?vue&type=template&id=a51f6bfe"
import script from "./CreativeListTable.vue?vue&type=script&lang=js"
export * from "./CreativeListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports